import { render } from "./ModalUploadExcel.vue?vue&type=template&id=312cf07b"
import script from "./ModalUploadExcel.vue?vue&type=script&lang=js"
export * from "./ModalUploadExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__